import React, { FC } from 'react'
import styled from 'styled-components'

type Props = {
  text: string
  onClick?: () => void
  href?: string
}

export const RjsfDescriptionLink: FC<Props> = ({ href, text, onClick }) => {
  return (
    <StyledA href={href} onClick={onClick}>
      {text}
    </StyledA>
  )
}

const StyledA = styled.a`
  color: white;
  cursor: pointer;
  text-decoration: underline;
`

export type LinkProps = Props
